import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import i18n from '../../../utils/i18n';
import { SectionDto } from '../types';

import { FeedTable } from './FeedTable';
import { GeneralDiscussionTable } from './GeneralDiscussionTable';

interface ViewThreadModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedMessageId: string;
  selectedActivity?: SectionDto;
  isGeneralDiscussion: boolean;
}

export const ViewThreadModal = ({
  isOpen,
  onClose,
  selectedMessageId,
  selectedActivity,
  isGeneralDiscussion,
}: ViewThreadModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'6xl'} isCentered>
      <ModalOverlay />

      <ModalContent height="70vh" overflowY="auto" overflowX="hidden">
        <ModalHeader>
          {isGeneralDiscussion
            ? i18n.t(
                'adBoardDetails.individualParticipant.viewThreadModalHeaderGeneralDiscussion'
              )
            : i18n.t(
                'adBoardDetails.individualParticipant.viewThreadModalHeader',
                {
                  selectedActivityIndex: (selectedActivity?.index ?? 0) + 1,
                  selectedActivityTitle: selectedActivity?.title,
                }
              )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY={'auto'}>
          {isGeneralDiscussion ? (
            <GeneralDiscussionTable selectedMessageId={selectedMessageId} />
          ) : (
            <FeedTable selectedMessageId={selectedMessageId} />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
